import { useQuery, useMutation, useQueryCache } from 'react-query'
import systemSettingsApi from '../../services/api/system-settings'
import useCacheKeys from '../use-cache-keys'
import STALE_TIMES from '../common/stale-times'
import { useCallback } from 'react'
import { find } from 'lodash'

const useSystemSettings = ({
    onSuccess = () => {},
    onError = () => {},
} = {}) => {

    const cacheKeys = useCacheKeys()
    const cache = useQueryCache()

    const { data, isLoading } = useQuery(cacheKeys.SETTINGS, () => systemSettingsApi.fetch(), { staleTime: STALE_TIMES.HOUR })

    const onUpdateSuccess = useCallback(() => {
        cache.invalidateQueries(cacheKeys.SETTINGS)
        onSuccess()
    }, [cache, cacheKeys, onSuccess])

    const [ updateSystemSetting, { isLoading: isUpdating }] = useMutation(({ id, value }) => systemSettingsApi.update({ id, value }), {
        onSuccess: onUpdateSuccess,
        onError
    })

    const systemSettings = data || []

    const emptyFormatter = d => d
    const intFormatter = d => parseInt(d)
    const stringFormatter = emptyFormatter

    const findSetting = (id, defaultValue = '0', formatter = emptyFormatter) => {
        const setting = find(systemSettings, { id })
        return formatter(setting ? setting.value : defaultValue)
    }

    const semesterDimensionRequirement = findSetting('semesterDimensionRequirement', '0', intFormatter)
    const courseDropLeadTime = parseInt(findSetting('courseDropLeadTime', '48', intFormatter))
    const progressTitle = findSetting('progressTitle', '', stringFormatter)

    return {
        isLoading,
        isLoadingSystemSettings: isLoading,
        systemSettings,
        isUpdating,
        updateSystemSetting,
        semesterDimensionRequirement,
        courseDropLeadTime,
        progressTitle
    }
}

export default useSystemSettings